import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import EditAmeniitesPageNew from "../../components/AccessType/AddAccessTypePageNew";



const EditAccessTypePage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>

        {/* Breadcrumb */}
        <Breadcrumb  id="title" title2="Access Type" link2="/accesstype" title="Edit Access Type" />

        {/* AddUserLayer */}
        <EditAmeniitesPageNew />


      </MasterLayout>
    </>
  );
};

export default EditAccessTypePage;
